import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";

export interface CreateIFRSQuestionResponseOptionDTO {
  fileType: "wordProcessor" | "spreadsheet";
  answerFileUrl: string;
}

export interface CreateIFRSQuestionResponseOptionResponse {
  id: string;
  fileType: string;
  answerFileUrl: string;
}

type CreateIFRSQuestionResponseOptionAPIResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: CreateIFRSQuestionResponseOptionResponse;
};

export const CreateIFRSQuestionResponseOption = async (
  questionId: string,
  data: FormData
): Promise<CreateIFRSQuestionResponseOptionAPIResponse> => {
  try {
    const response = await axios.post(
      `/ifrs-question/${questionId}/response-options`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return { data: response.data.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
